import { render, staticRenderFns } from "./time-display.vue?vue&type=template&id=790ae8f2&scoped=true"
import script from "./time-display.vue?vue&type=script&lang=ts&setup=true"
export * from "./time-display.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./time-display.vue?vue&type=style&index=0&id=790ae8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ae8f2",
  null
  
)

export default component.exports